import { ThemeEvents } from "@theme/events";

/**
 * Displays a product price and reacts to variant changes.
 *
 * Listens on `document` for `variant:update` events so it works regardless of
 * where the variant picker lives in the DOM (e.g. inside a drawer/modal that
 * sits outside the .shopify-section).
 *
 * On variant change the component finds its counterpart in the freshly fetched
 * section HTML and swaps its own content, keeping all formatting server-side.
 */
class ProductPriceDisplay extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /** @param {import("@theme/events").VariantUpdateEvent} event */
  #onVariantUpdate = (event) => {
    const { resource, data } = event.detail;
    if (!resource || !data?.html) return;

    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (data.productId !== this.dataset.productId) {
      return;
    }

    const updated = data.html.querySelector(`product-price-display[data-product-id="${this.dataset.productId}"]`);
    if (!updated) return;

    this.innerHTML = updated.innerHTML;
  };
}

if (!customElements.get("product-price-display")) {
  customElements.define("product-price-display", ProductPriceDisplay);
}
